import {
  IconButton,
  IconButtonProps,
  Text,
  TextProps,
  VStack
} from '@chakra-ui/react';
import { FC, MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

type LabeledIconButtonProps = {
  buttonProps: (
    | { to: string; onClick?: never }
    | { to?: never; onClick: MouseEventHandler }
  ) &
    Omit<IconButtonProps, 'aria-label'>;
  textProps: {
    content: string;
  } & TextProps;
};

/**
 * 直下に文字の配置がされているIconButton
 * アイコンボタンの下にラベルテキストを表示する汎用コンポーネント
 */
const LabeledIconButton: FC<LabeledIconButtonProps> = ({
  buttonProps: { onClick, to, ...otherButtonProps },
  textProps: { content, ...otherTextProps }
}) => (
  <VStack gap="0">
    <IconButton
      as={to ? Link : undefined}
      variant="outline"
      size="lg"
      border="1px"
      backgroundColor="#F7F7F7"
      isRound
      {...otherButtonProps}
      to={to}
      aria-label={content}
      onClick={!to ? onClick : undefined}
    />
    <Text fontSize="lg" {...otherTextProps}>
      {content}
    </Text>
  </VStack>
);

export default LabeledIconButton;
